import React, { useEffect, useState, useContext } from 'react'
import { IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/react'
import { LineChart, XAxis, YAxis, Line, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts'
import { ConfigContext } from '../../contexts/ConfigContext';
var moment = require('moment');

const SalesGraph = () => {

    const [Data, setData] = useState([])
    const { getInvoices, getPurchase } = useContext(ConfigContext)

    useEffect(() => {
        Promise.all([getInvoices(), getPurchase()]).then(res => {
            const invoices = res[0]
            const purchases = res[1]
            let d = calcSalePurchase(invoices, purchases);
            setData(d)
        })
        return () => {
            setData([])
        }
    }, [getInvoices, getPurchase])

    const chart = (
        <ResponsiveContainer aspect={1.77} width={'100%'}>
            <LineChart data={Data} >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey='date' />
                <YAxis dataKey="sale" domain={['auto', 'auto']} />
                <Tooltip />
                <Legend />
                <Line dataKey="sale" type="monotoneX" stroke="#2584d8" dot={false} padding={{ left: 10, right: 10 }} />
                <Line dataKey="purchase" type="monotoneX" stroke=" #00ff7f" dot={false} />

            </LineChart>
        </ResponsiveContainer>
    )

    return (
        <IonCard>
            <IonCardHeader>
                <IonCardTitle>Sales Graph</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>{chart}</IonCardContent>
        </IonCard>
    )
}

// eslint-disable-next-line no-extend-native
Date.prototype.addDay = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
};

function getDaysArray(strDate, stpDate) {
    var dArray = [];
    var cDate = strDate;
    while (cDate <= stpDate) {
        // Adding the date to array 
        dArray.push(new Date(cDate));
        // Increment the date by 1 day 
        cDate = cDate.addDay(1);
    }
    return dArray;
}

export const calcSalePurchase = (Invoices, Purchase, fromDate = new Date().addDay(-30), toDate = new Date()) => {
    const saleData = [];
    let dates = getDaysArray(fromDate, toDate);
    // console.log(dates);
    // console.log(Invoices);
    dates.forEach((day) => {
        let daySale = 0;
        let dayPurchase = 0;
        let dayInvoices = Invoices.filter((bill => (moment(bill.billDate).format('ll') === moment(day).format('ll'))))
        let dayBills = Purchase.filter((bill => (moment(bill.billDate).format('ll') === moment(day).format('ll'))))
        dayInvoices.forEach(bill => {
            daySale += bill.totalAmt;
        })
        dayBills.forEach(bill => {
            dayPurchase += bill.totalAmt;
        })
        saleData.push({
            date: moment(day).format('ll'),
            sale: daySale,
            purchase: dayPurchase
        });
        // console.log(daySale);

    });
    return saleData;
};

export default SalesGraph
